export const EM_DASH = '—';

export function formatUsd(value: number | null | undefined): string {
    if (value == null) return EM_DASH;
    const abs = Math.abs(value);
    if (abs >= 1_000_000_000) return `$${(value / 1_000_000_000).toFixed(1)}B`;
    if (abs >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`;
    if (abs >= 1_000) return `$${(value / 1_000).toFixed(1)}K`;
    return `$${value.toFixed(0)}`;
}

export function formatCents(value: number | null | undefined): string {
    if (value == null) return EM_DASH;
    return `${(value * 100).toFixed(1)}¢`;
}

export function formatSignedPct(value: number | null | undefined): string {
    if (value == null) return EM_DASH;
    const pct = value * 100;
    const sign = pct > 0 ? '+' : '';
    return `${sign}${pct.toFixed(1)}%`;
}

export function formatDate(value: string | null | undefined): string {
    if (!value) return EM_DASH;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return EM_DASH;
    return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
    });
}

export function statusColor(status: string): string {
    if (status === 'open') return '#00C853';
    if (status === 'closed') return '#E53935';
    if (status === 'resolved') return '#2979FF';
    return '#BA7517';
}

export function changeColor(value: number | null | undefined): string {
    if (value == null || value === 0) return 'text.disabled';
    return value > 0 ? '#0F6E56' : '#A32D2D';
}